import { TASK_STATUSES } from '../constants/auditResults';

// eslint-disable-next-line import/prefer-default-export
export function createAuditTask(sessionActivity) {
  return {
    sessionActivity,
    taskStatus: TASK_STATUSES.PENDING,
    verdict: null,
    errorMessage: null,
    errorCode: null,

    markProcessing() {
      this.taskStatus = TASK_STATUSES.PROCESSING;
      this.errorMessage = null;
      this.errorCode = null;
    },
    markCompleted(verdict) {
      this.taskStatus = TASK_STATUSES.COMPLETED;
      this.verdict = verdict;
      this.errorMessage = null;
      this.errorCode = null;
    },
    markFailed({ message = null, code = null } = {}) {
      this.taskStatus = TASK_STATUSES.FAILED;
      this.errorMessage = message;
      this.errorCode = code;
    },
    markCancelled() {
      this.taskStatus = TASK_STATUSES.CANCELLED;
    },
    isPending() {
      return this.taskStatus === TASK_STATUSES.PENDING;
    },
  };
}
